import React, { Component, Fragment } from 'react'
import { ThemeProvider } from 'styled-components'
import Papa from 'papaparse'
import moment from 'moment'
import 'moment/min/locales.min'

import WeekView from '../../components/WeekView/WeekView'
import MobileView from '../../components/MobileView/MobileView'
import PrintView from '../../components/PrintView/PrintView'
import KioskView from '../../components/KioskView/KioskView'
import LabelView from '../../components/LabelView/LabelView'

import Themes from 'themes'
import Settings from 'settings'

import NoDataSegment from '../../components/NoDataSegment/NoDataSegment'
import Loader from '../../components/Loader/Loader'
import { getSlugFromString } from '../../utils/mongo_utils'
import Axios from 'axios'
import { LoaderConsumer } from '../../utils/LoadingContext'

import { createGlobalStyle } from 'styled-components'
import { getLanguage } from '../../utils/Locale'

import axios from 'axios'
import { computeWinrestHash } from '../../utils/Crypto'
import { WINREST_API_BASE_URL } from '../../utils/Config'

const GlobalStyle = createGlobalStyle`
    body {
        background-color: ${props =>
            props.forceWhiteBackground ? '#fff' : props.theme.background};

        font-family: ${props => props.theme.content_font_family}; 
    }
`

class MenuPanel extends Component {
    state = {
        days: [],
        items: [],
    }

    componentWillMount() {
        const { dataSource } = this.props
        if (dataSource === 'excel') {
            this.parseCsvFile(this.props)
        } else if (dataSource === 'winrest') {
            this.fetchWinrestData()
        } else if (dataSource === 'winrest2') {
            this.fetchWinrestData2()
        }
    }

    componentDidUpdate = async (prevProps, prevState) => {
        const {
            dataSource = '',
            siteId,
            pointOfSaleSlug,
            winrestURL,
            language,
            guestTypeSlug,
            mealTypeSlug,
            menuSlug,
        } = prevProps
        const newPrevProps = { ...prevProps }
        delete newPrevProps.loading
        let { loading, ...restOfCurrent } = this.props

        const isThereChanges =
            JSON.stringify(newPrevProps) !== JSON.stringify(restOfCurrent)

        const shouldReloadFile =
            this.props.title === prevProps.title &&
            this.props.hideMenuPrice === prevProps.hideMenuPrice &&
            this.props.hideRecipePoints === prevProps.hideRecipePoints &&
            this.props.hideEnergyKcal === prevProps.hideEnergyKcal &&
            this.props.showEnergyKcalByPortion === prevProps.showEnergyKcalByPortion && 
            this.props.hideComposition === prevProps.hideComposition &&
            this.props.hideLabels === prevProps.hideLabels &&
            this.props.useCommercialName === prevProps.useCommercialName &&
            this.props.isDuoKiosk === prevProps.isDuoKiosk &&
            this.props.zoom === prevProps.zoom

        if (isThereChanges && shouldReloadFile) {
            if (dataSource === 'excel') {
                this.parseCsvFile(this.props)
            } else if (
                dataSource === 'winrest' &&
                siteId &&
                pointOfSaleSlug &&
                winrestURL &&
                language &&
                guestTypeSlug &&
                mealTypeSlug &&
                menuSlug
            ) {
                if (
                    this.props.recipes !== prevProps.recipes ||
                    this.props.dayCount !== prevProps.dayCount ||
                    this.props.startDay !== prevProps.startDay ||
                    this.props.language !== prevProps.language ||
                    this.props.displayMode !== prevProps.displayMode ||
                    this.props.excludedDays !== prevProps.excludedDays
                ) {
                    this.fetchWinrestData()
                }
            } else if (dataSource === 'winrest2') {
                this.fetchWinrestData2()
            }
        }
    }

    getKioskPicture = kiosk => {
        const { winrestData, concept } = this.props
        if (
            winrestData &&
            winrestData.pictures &&
            winrestData.pictures[concept]
        ) {
            return winrestData.pictures[concept][kiosk]
        } else {
            const picturesStr = localStorage.getItem('winrest-recipes-pictures')
            if (!picturesStr) {
                return null
            }
            const picturesValue = JSON.parse(picturesStr)
            if (!picturesValue[this.props.concept]) {
                return null
            }
            return picturesValue[this.props.concept][kiosk]
        }
    }

    sortByRecipeTypes = (recipe1, recipe2, recipeTypes) => {
        if (!recipeTypes || recipeTypes == '' || recipeTypes == []) return 0

        if (typeof recipeTypes == 'string') {
            recipeTypes = recipeTypes.split(',')
        }

        const recipeTypesArr = recipeTypes.map((r, i) => {
            return { index: i, value: r.toLowerCase() }
        })

        const recipe1Type = recipeTypesArr.find(
            r => r.value == recipe1.toLowerCase()
        )
        const recipe2Type = recipeTypesArr.find(
            r => r.value == recipe2.toLowerCase()
        )

        if (!recipe1Type) return 1
        if (!recipe2Type) return -1

        if (recipe1Type.index < recipe2Type.index) return -1
        if (recipe1Type.index > recipe2Type.index) return 1

        return 0
    }

    fetchWinrestData2 = async () => {
        const { winrestData } = this.props

        const baseUrl = winrestData
            ? winrestData.baseUrl
            : this.props.winrestURL
        const siteId = winrestData ? winrestData.siteId : this.props.siteId
        const pointOfSaleId = winrestData
            ? winrestData.pointOfSaleId
            : this.props.pointOfSaleId
        const menuId = winrestData ? winrestData.menuId : this.props.menuId

        const recipeTypes = winrestData
            ? winrestData.selectedRecipeTypes
            : this.props.recipeTypeIds
            ? this.props.recipeTypeIds.split(',')
            : []

        const pictures = this.props.pictures
            ? this.props.pictures.split(',')
            : null

        const includedDays = this.getIncludedDays()

        if (!siteId) {
            return
        }

        let menus = []
        let kiosks = []
        if (!winrestData) {
            this.props.setLoading()

            const countryCode = baseUrl.split('.')[0].replace('wr', '')

            const urls = []
            for (let i = 0; i < includedDays.length; i++) {
                const d = includedDays[i].format('YYYY-MM-DD')

                const url = `sites/${siteId}/pointsOfSale/${d}`
                const key = computeWinrestHash(url)
                urls.push({
                    key,
                    url: `${url}?deliveryId=${pointOfSaleId}&menuId=${menuId}`,
                })
            }

            // const values = await Promise.all(
            //     urls.map(_ =>
            //         axios.get(`https://${baseUrl}/${_.url}`, {
            //             headers: { bearer: _.key },
            //         })
            //     )
            // )
            const values = []
            for (let i = 0; i < urls.length; i++) {
                const value = await axios.get(
                    `${WINREST_API_BASE_URL}/${countryCode}/${urls[i].url}`,
                    {
                        headers: { bearer: urls[i].key },
                    }
                )
                values.push(value)
            }

            for (let i = 0; i < values.length; i++) {
                if (!values[i].data || !values[i].data[0].menus) {
                    continue
                }
                let menu = values[i].data[0].menus[0]
                kiosks.push({
                    date: menu.date.slice(0, 10),
                    currency: menu.currency,
                    recipes: {
                        ...this._groupBy(menu.recipes, 'recipeTypeName'),
                        ...this._groupBy(menu.recipes, 'defaultKiosk'),
                    },
                })

                const recipesCopy = []
                menu.recipes.forEach(_ =>
                    recipesCopy.push(Object.assign({}, _))
                )
                const groupedByDefaultKiosk = this._groupBy(
                    recipesCopy,
                    'defaultKiosk'
                )
                const defaultKiosks = Object.keys(groupedByDefaultKiosk).map(
                    _ => {
                        return groupedByDefaultKiosk[_].map(a => {
                            a.recipeTypeName = a.defaultKiosk
                            return a
                        })
                    }
                )
                const defaultKiosksFlattenArray = []
                defaultKiosks.forEach(_ => {
                    _.forEach(a => defaultKiosksFlattenArray.push(a))
                })
                menu = {
                    ...menu,
                    recipes: menu.recipes.concat(defaultKiosksFlattenArray),
                }
                menus.push(menu)
            }
        } else {
            menus = winrestData.menus
            kiosks = winrestData.kiosks
        }

        let items = []
        const pictureValues = JSON.parse(pictures)

        if (this.props.displayMode === 'week') {
            const result = []
            // Create structure for weekly display (grouped by kiosk, then date)
            menus.forEach(menu => {
                menu.recipes
                    .filter(_ => recipeTypes.includes(_.recipeTypeName))
                    .forEach((recipe, i) => {
                        const allergensByType = this._groupBy(
                            recipe.intolerance,
                            'allergenType'
                        )
                        const allergens = Object.keys(allergensByType).reduce(
                            (res, _, i) => {
                                res[`Allergenes ${i + 1}`] = _
                                return res
                            },
                            {}
                        )
                        const updatedRecipe = {
                            ...recipe,
                            menu_board_label: this.getNameValue(recipe),
                            ...allergens,
                            ...(recipe.keywords && {
                                label: recipe.keywords[0],
                                caracteristique_produit: recipe.keywords[1]
                            }),
                            price_point: recipe.pointPrice
                        }
                        const updateDate = menu.date.slice(0, 10)

                        const recipeTypeName = this.getRecipeTypeName(recipe)

                        const kioskExists = result.find(
                            _ => _.name === recipeTypeName
                        )
                        if (kioskExists) {
                            const dateExists = kioskExists.items.find(
                                _ => _.date === updateDate
                            )
                            if (dateExists) {
                                dateExists.items.push(updatedRecipe)
                            } else {
                                kioskExists.items.push({
                                    date: updateDate,
                                    items: [updatedRecipe],
                                })
                            }
                        } else {
                            result.push({
                                name: recipeTypeName,
                                order: recipeTypes.indexOf(recipeTypeName),
                                items: [
                                    {
                                        date: updateDate,
                                        items: [updatedRecipe],
                                    },
                                ],
                                //order: 1,
                                //kioskPicture: kioskPicture
                                kioskPicture: pictures
                                    ? pictureValues[recipe.recipeTypeName]
                                    : this.getKioskPicture(
                                          recipe.recipeTypeName
                                      ),
                            })
                        }
                    })
            })

            result.sort((r1, r2) => {
                return r1.order - r2.order
            })

            // Fill in the missing dates so that empty days are displayed
            items = result
                .map(r => {
                    return {
                        ...r,
                        items: includedDays.map(d => {
                            const item = r.items.find(
                                _ => _.date === d.format('YYYY-MM-DD')
                            )
                            if (item) {
                                return item
                            } else {
                                return {
                                    date: d.format('YYYY-MM-DD'),
                                    items: [],
                                }
                            }
                        }),
                    }
                })
        } else {
            items = (kiosks || []).map(kiosk => {
                return {
                    kiosks: Object.keys(kiosk.recipes)
                        .filter(_ => recipeTypes.includes(_))
                        .sort((r1, r2) =>
                            this.sortByRecipeTypes(r1, r2, recipeTypes)
                        )
                        .map((_, i) => {
                            return {
                                name: this.getRecipeTypeName(
                                    kiosk.recipes[_][0]
                                ),
                                items: kiosk.recipes[_].map(item => {
                                    const allergensByType = this._groupBy(
                                        item.intolerance,
                                        'allergenType'
                                    )
                                    const allergens = Object.keys(
                                        allergensByType
                                    ).reduce((res, _, i) => {
                                        res[`Allergenes ${i + 1}`] = _
                                        return res
                                    }, {})
                                    return {
                                        ...item,
                                        menu_board_label: this.getNameValue(
                                            item
                                        ),
                                        composition: this.formatComposition(
                                            item.composition
                                        ),
                                        ...allergens,
                                        energyKCal:
                                            item.energyKCal &&
                                            `${item.energyKCal} kCal`,
                                        energyKCalByPortion: 
                                            item.energyKCalByPortion &&
                                            `${item.energyKCalByPortion} kCal`,
                                        currency: kiosk.currency,
                                        price: item.price > 0 ? item.price.toFixed(2) : 0,
                                        ...(item.keywords && {
                                            label: item.keywords[0],
                                            caracteristique_produit:
                                                item.keywords[1],
                                        }),
                                        price_point: item.pointPrice
                                    }
                                }),
                                //order: recipeIndex,
                                kioskPicture: pictures
                                    ? pictureValues[_]
                                    : this.getKioskPicture(_),
                            }
                        }),
                    date: kiosk.date,
                    currency: kiosk.currency,
                }
            })
        }

        this.setState(
            {
                items,
                currency: '€',
                days: includedDays.map(item => {
                    return {
                        date: item,
                        name: item.locale('en').format('dddd'),
                    }
                }),
            },
            () => this.props.setUnloading()
        )
    }

    fetchWinrestData = async () => {
        let {
            winrestURL,
            siteId,
            siteSlug,
            menuSlug,
            pointOfSale,
            pointOfSaleSlug,
        } = this.props

        if (!menuSlug) {
            return
        }

        this.props.setLoading()

        const countryCode = winrestURL.split('.')[0].replace('wr', '')
        const path = "Information"
        let url = `${WINREST_API_BASE_URL}/${countryCode}/${path}`
        let result = await Axios.get(`https://${winrestURL}/${url}`, {
            headers: { bearer: computeWinrestHash(path) },
        })

        if (!result) {
            throw new Error(`Can't fetch sites informations `)
        }

        const informations = result.data

        if (!siteId && siteSlug) {
            const site = result.data.Sites.find(
                _ => getSlugFromString(_.name) === siteSlug
            )
            if (!site) {
                throw new Error(`Can't fetch sites informations `)
            }
            siteId = site.id
        }

        const includedDays = this.getIncludedDays()

        const menus = []

        const urls = []
        for (let i = 0; i < includedDays.length; i++) {
            const date = includedDays[i].format('YYYY-MM-DD')

            const path = `sites/${siteId}/pointsOfSale/${date}`
            url = `${WINREST_API_BASE_URL}/${countryCode}/${path}`
            key = computeWinrestHash(path)
            urls.push({ key, url })
        }

        const values = await Promise.all(
            urls.map(_ =>
                Axios.get(_.url, {
                    headers: { bearer: _.key },
                })
            )
        )

        for (let i = 0; i < values.length; i++) {
            const result = values[i]

            if (result && result.data) {
                const posName = pointOfSale || pointOfSaleSlug
                //console.log('posName', posName)
                const data = result.data.find(
                    _ => getSlugFromString(_.name) === posName
                )
                if (!data) {
                    console.error(`[ERR] there is no ${posName} pos`)
                    continue
                }
                //console.log('menu', menuSlug)
                const menu = data.menus.find(
                    _ => getSlugFromString(_.name) === menuSlug
                )
                if (!menu) {
                    console.error(`[ERR] there is no ${menuSlug} menu`)
                    continue
                }
                menus.push(menu)
            }
        }

        const { recipes, language } = this.props

        const allRecipes = menus.reduce((res, menu) => {
            res.push(
                ...menu.recipes.map(_ => ({
                    ..._,
                    date: menu.date.slice(0, 10),
                }))
            )
            return res
        }, [])

        let items

        if (this.props.displayMode === 'week') {
            const recipesGroupedByType = this._groupBy(
                allRecipes,
                'recipeTypeId'
            )
            items = Object.keys(recipesGroupedByType)
                .reduce((res, _) => {
                    const recipeType = informations.TypeRecipes.find(
                        t => t.id === parseInt(_)
                    )
                    const recipeIndex = recipes.findIndex(
                        _ =>
                            _.split('-')[0] ===
                            getSlugFromString(recipeType.name)
                    )
                    const recipe = recipes[recipeIndex]
                    if (!recipe) {
                        return res
                    }

                    const kioskPicture = recipe.split('-')[1]

                    const recipesGroupedByDate = this._groupBy(
                        recipesGroupedByType[_],
                        'date'
                    )

                    res.push({
                        name: recipeType.name,

                        items: includedDays.map(d => {
                            const date = d.format('YYYY-MM-DD')
                            if (!recipesGroupedByDate[date]) {
                                return {
                                    date,
                                    items: [],
                                }
                            }
                            return {
                                date,
                                items: recipesGroupedByDate[date]
                                    .map(_ => {
                                        const allergensByType = this._groupBy(
                                            _.intolerance,
                                            'allergenType'
                                        )
                                        const allergens = Object.keys(
                                            allergensByType
                                        ).reduce((res, _, i) => {
                                            res[`Allergenes ${i + 1}`] = _
                                            return res
                                        }, {})

                                        return {
                                            ..._,
                                            ...allergens,
                                            menu_board_label: this.getNameValue(
                                                _
                                            ),
                                        }
                                    })
                                    .sort((a, b) => b.id - a.id),
                            }
                        }),
                        order: recipeIndex, // recipeType.order,
                        kioskPicture: kioskPicture,
                    })
                    return res
                }, [])
                .sort((a, b) => {
                    return a.order - b.order
                })
        } else {
            items = menus.map(_ => {
                const date = _.date.slice(0, 10)
                const name = _.name
                const currency = this.props.currency || _.currency || 'e'

                const recipesGroupedByType = this._groupBy(
                    _.recipes,
                    'recipeTypeId'
                )
                const kiosks = Object.keys(recipesGroupedByType)
                    .map(_ => {
                        const recipeType = informations.TypeRecipes.find(
                            t => t.id === parseInt(_)
                        )
                        //console.log('recipeType.name', recipeType.name)
                        const recipeIndex = recipes.findIndex(
                            _ =>
                                _.split('-')[0] ===
                                getSlugFromString(recipeType.name)
                        )
                        const recipe = recipes[recipeIndex]
                        if (!recipe) {
                            console.error(
                                `[ERR] there is no ${getSlugFromString(
                                    recipeType.name
                                )} recipe`
                            )
                            return
                        }

                        const kioskPicture = recipe.split('-')[1]

                        return {
                            name: recipeType.name,
                            items: recipesGroupedByType[_].map(r => {
                                const allergensByType = this._groupBy(
                                    r.intolerance,
                                    'allergenType'
                                )
                                const allergens = Object.keys(
                                    allergensByType
                                ).reduce((res, _, i) => {
                                    res[`Allergenes ${i + 1}`] = _
                                    return res
                                }, {})
                                return {
                                    menu_board_label: this.getNameValue(r),
                                    ...r,
                                    ...allergens,
                                    composition: this.formatComposition(
                                        r.composition
                                    ),
                                    price_point:
                                        r.energyKCal && `${r.energyKCal} kCal`,
                                    //price_currency: r.price.toFixed(2)
                                    currency,
                                }
                            }).sort((a, b) => b.id - a.id),
                            kioskPicture: kioskPicture,
                            order: recipeIndex,
                        }
                    })
                    .filter(_ => _)
                    .sort((a, b) => {
                        return a.order - b.order
                    })

                return {
                    date,
                    name,
                    kiosks,
                    currency,
                }
            })
        }

        this.setState(
            {
                items,
                currency: '€',
                days: includedDays.map(item => {
                    return {
                        date: item,
                        name: item.locale(getLanguage(language)).format('dddd'),
                    }
                }),
            },
            () => this.props.setUnloading()
        )
    }

    getNameValue = item => {
        const { language } = this.props
        let winrestLanguage = language
        if (language.indexOf('_') !== -1) {
            winrestLanguage = winrestLanguage.split('_')[0]
        } else {
            winrestLanguage = 'commercialName1'
        }
        return item[winrestLanguage]
    }

    getRecipeTypeName = recipeType => {
        const { language } = this.props
        let winrestLanguage = language
        if (
            language.indexOf('_') !== -1 &&
            winrestLanguage.split('_')[0] === 'commercialName2'
        ) {
            winrestLanguage = 'recipeTypeCommercialName2'
        } else {
            winrestLanguage = 'recipeTypeCommercialName1'
        }

        return recipeType[winrestLanguage]
    }

    formatComposition = composition => {
        if (!composition) {
            return ''
        }
        const compositionArray = composition.split(' - ')
        let newComposition = ''
        let nextComposition = ''
        let ingredientsFinished = false

        compositionArray.map((ingredient, i) => {
            nextComposition = newComposition + ingredient
            if (i + 1 === compositionArray.length && !ingredientsFinished) {
                const replacement = '.'
                newComposition = nextComposition.replace(
                    /,([^,]*)$/,
                    replacement + '$1'
                )
            } else if (nextComposition.length > 105 && !ingredientsFinished) {
                ingredientsFinished = true
                newComposition = newComposition + '...'
                return
            } else if (!ingredientsFinished) {
                newComposition = nextComposition + ', '
            }
        })

        if (newComposition.length > 120) {
            newComposition = newComposition.substr(0, 120)
        }

        return newComposition
    }

    getIncludedDays = () => {
        let { language, excludedDays = [], startDay } = this.props
        const date = moment(this.props.date)
        let includedDays = [date]
        if (this.props.dayCount > 1 && this.props.displayMode !== 'print') {
            // const firstDayOfWeek = date.locale(this.props.language).startOf('week');
            const days = [
                'sunday',
                'monday',
                'tuesday',
                'wednesday',
                'thurday',
                'friday',
                'saturday',
            ]
            moment.updateLocale(getLanguage(language), {
                week: {
                    dow:
                        startDay === 'today'
                            ? moment().day()
                            : days
                                  .filter(day => day !== 'today')
                                  .indexOf(startDay),
                },
            })
            const firstDayOfWeek = date
                .locale(getLanguage(language))
                .startOf('week')
            includedDays = [firstDayOfWeek]
            for (let i = 0; i < this.props.dayCount - 1; i++) {
                if (!includedDays[i]) {
                    continue
                }
                const dayToAdd = includedDays[i].clone().add(1, 'd')
                includedDays.push(dayToAdd)
            }
        }
        return includedDays.filter(_ => excludedDays.indexOf(_.day()) === -1)
    }

    parseCsvFile = props => {
        const { language } = props
        moment.locale(getLanguage(language))
        this.props.setLoading()

        const rootPath = Settings.data_root_path[process.env.NODE_ENV]
        const filePath = `${rootPath}/${props.entityId}/${props.siteId}/${
            props.file
        }?_=${new Date().getTime()}`
        Papa.parse(filePath, {
            delimiter: ';',
            header: true,
            delimiter: ';',
            download: true,
            skipEmptyLines: true,
            complete: this.onParseComplete,
            error: this.onParseError,
        })
    }

    onParseComplete = result => {
        const includedDays = this.getIncludedDays()
        /**
         * Structure items based on display mode
         */
        const items =
            this.props.displayMode === 'week'
                ? this.getWeeklyItems(result, includedDays)
                : this.getDailyItems(result, includedDays)

        /**
         * Update the state
         */
        this.setState({
            items,
            days: includedDays.map(item => {
                return {
                    date: item,
                    name: item.format('dddd'),
                }
            }),
        })
        this.props.setUnloading()
    }

    onParseError = (err, file, inputElem, reason) => {
        console.log(err)
    }

    /**
     * Get items structure for daily display
     */
    getDailyItems = (result, includedDays) => {
        const filteredResult = this.getFilteredData(result.data)

        const includedDaysStr = includedDays.map(_ => _.format('YYYY-MM-DD'))

        const groupedByDate = this._groupBy(filteredResult, 'date')

        const kiosksNames = this.props.kiosks.map(kiosk => kiosk.split('-')[0])
        const selectedMenu = result.data.find(
            it => it.menu_code == this.props.menu
        )
        const dailyItems = Object.keys(groupedByDate)
            .reduce((result, date) => {
                if (includedDaysStr.indexOf(date) !== -1) {
                    const byKiosk = this._groupBy(
                        groupedByDate[date],
                        'kiosk_code'
                    )

                    const kiosks = Object.keys(byKiosk).reduce(
                        (result, kiosk) => {
                            if (
                                kiosksNames[0] === 'all' ||
                                kiosksNames.indexOf(kiosk) !== -1
                            ) {
                                result.push({
                                    name: kiosk,
                                    displayName: byKiosk[kiosk][0].kiosk_name,
                                    kioskPicture: this.props.kiosks
                                        .find(
                                            singleKiosk =>
                                                singleKiosk.split('-')[0] ===
                                                kiosk
                                        )
                                        .split('-')[1],
                                    items: byKiosk[kiosk],
                                    order: kiosksNames.indexOf(kiosk),
                                })
                            }
                            return result
                        },
                        []
                    )

                    result.push({
                        date: date,
                        kiosks: kiosks.sort((a, b) => {
                            return a.order - b.order
                        }),
                        menus: this._groupBy(groupedByDate[date], 'menu_code'),
                        price_currency: selectedMenu.offer1_price_currency,
                        menu_label: selectedMenu.menu_label,
                    })
                }
                return result
            }, [])
            .sort((a, b) => {
                return a.order - b.order
            })
            .sort((a, b) => {
                return a.date < b.date ? -1 : a.date > b.date ? 1 : 0
            })
        includedDaysStr.map((day, i) => {
            if (!dailyItems.find(item => item.date === day)) {
                dailyItems.splice(i, 0, { date: day, kiosks: [] })
            }
        })

        const filteredDailyItems = dailyItems.filter(_ => {
            return _.kiosks.length > 0
        })

        return filteredDailyItems
    }

    /**
     * Get items structure for weekly display
     */
    getWeeklyItems = (result, includedDays) => {
        const filteredResult = this.getFilteredData(result.data)

        const groupedByKiosk = this._groupBy(filteredResult, 'kiosk_code')
        const kiosksNames = this.props.kiosks.map(kiosk => kiosk.split('-')[0])
        const weeklyItems = Object.keys(groupedByKiosk)
            .reduce((result, item) => {
                if (
                    kiosksNames[0] === 'all' ||
                    kiosksNames.indexOf(item) !== -1
                ) {
                    const byDate = this._groupBy(groupedByKiosk[item], 'date')
                    const items = includedDays.map(day => {
                        return {
                            date: day.format('YYYY-MM-DD'),
                            items: byDate[day.format('YYYY-MM-DD')],
                        }
                    })

                    result.push({
                        name: item,
                        items: items,
                        kioskPicture: this.props.kiosks
                            .find(
                                singleKiosk =>
                                    singleKiosk.split('-')[0] === item
                            )
                            .split('-')[1],
                        order: kiosksNames.indexOf(item),
                    })
                }
                return result
            }, [])
            .sort((a, b) => {
                return a.order - b.order
            })

        return weeklyItems
    }

    getFilteredData = data =>
        data.filter(
            _ =>
                !!_.date &&
                _.language === this.props.language &&
                _.service === this.props.service
        )

    render() {
        const {
            dataSource,
            language,
            hideMenuPrice,
            hideRecipePoints,
            hideEnergyKcal,
            showEnergyKcalByPortion,
            currency = this.state.currency || '',
            useCommercialName,
            hideComposition,
            hideLabels,
            hideIntolerences,
            isDuoKiosk,
            isAdministrationPanel,
        } = this.props
        const { days = [], items = [] } = this.state
        const { loading } = this.props
        // if (loading && isAdministrationPanel) return <Loader />
        if (
            (loading && isAdministrationPanel) ||
            (loading && this.props.displayMode !== 'kiosk')
        )
            return <Loader />

        if (
            isAdministrationPanel &&
            (!days || days.length === 0 || !items || items.length === 0)
        ) {
            return (
                <Fragment>
                    <NoDataSegment message="There is not enough data to show the menu." />
                </Fragment>
            )
        }

        const today = moment().format('YYYY-MM-DD')
        let selectedIndex = this.state.items.findIndex(_ => {
            return _.date === today
        })
        if (selectedIndex === -1) {
            selectedIndex = 0
        }

        let theme = Themes[this.props.concept]
        if (!theme) {
            theme = Themes[Object.keys(Themes)[0]]
        }

        if (!items) {
            return null
        }

        return (
            <ThemeProvider theme={theme}>
                <Fragment>
                    {this.props.displayMode === 'print' ||
                    (this.props.print && this.props.displayMode !== 'week') ? (
                        <PrintView
                            title={this.props.title}
                            orientation={this.props.orientation}
                            zoom={this.props.zoom}
                            size={this.props.size}
                            items={items[selectedIndex]}
                            concept={this.props.concept}
                            menu={this.props.menu}
                            isReady={!loading}
                            dataSource={dataSource}
                            language={language}
                            currency={currency}
                            useCommercialName={useCommercialName}
                            hideMenuPrice={hideMenuPrice}
                            hideRecipePoints={hideRecipePoints}
                            hideEnergyKcal={hideEnergyKcal}
                            showEnergyKcalByPortion={showEnergyKcalByPortion}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}
                            isAdmin={isAdministrationPanel}
                            showDate={this.props.showDate}
                        />
                    ) : this.props.displayMode === 'week' && days.length ? (
                        <WeekView
                            title={this.props.title}
                            days={days || []}
                            items={items}
                            concept={this.props.concept}
                            isReady={!loading}
                            orientation={'landscape'}
                            dataSource={dataSource}
                            language={language}
                            zoom={this.props.zoom}
                            currency={currency}
                            useCommercialName={useCommercialName}
                            hideMenuPrice={hideMenuPrice}
                            hideRecipePoints={hideRecipePoints}
                            hideEnergyKcal={hideEnergyKcal}
                            showEnergyKcalByPortion={showEnergyKcalByPortion}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}
                            print={this.props.print}
                        />
                    ) : this.props.displayMode === 'day' ? (
                        <MobileView
                            title={this.props.title}
                            subtitle={this.props.subtitle}
                            startIndex={selectedIndex}
                            items={items}
                            concept={this.props.concept}
                            isReady={!loading}
                            dataSource={dataSource}
                            language={language}
                            zoom={this.props.zoom}
                            currency={currency}
                            useCommercialName={useCommercialName}
                            hideMenuPrice={hideMenuPrice}
                            hideRecipePoints={hideRecipePoints}
                            hideEnergyKcal={hideEnergyKcal}
                            showEnergyKcalByPortion={showEnergyKcalByPortion}
                            hideComposition={hideComposition}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}  
                        />
                    ) : this.props.displayMode === 'printlabel' ? (
                        <LabelView
                            title={this.props.title}
                            orientation={this.props.orientation}
                            zoom={this.props.zoom}
                            size={this.props.size}
                            items={items}
                            concept={this.props.concept}
                            menu={this.props.menu}
                            isReady={!loading}
                            dataSource={dataSource}
                            language={language}
                            currency={currency}
                            useCommercialName={useCommercialName}
                            hideMenuPrice={hideMenuPrice}
                            hideRecipePoints={hideRecipePoints}
                            hideEnergyKcal={hideEnergyKcal}
                            showEnergyKcalByPortion={showEnergyKcalByPortion}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}
                            hideComposition={hideComposition}
                            isAdmin={isAdministrationPanel}
                            showDate={this.props.showDate}
                        />
                    ) : this.props.displayMode === 'kiosk' ? (
                        <KioskView
                            title={this.props.title}
                            subtitle={this.props.subtitle}
                            zoom={this.props.zoom}
                            items={items[selectedIndex]}
                            concept={this.props.concept}
                            menu={this.props.menu}
                            isReady={!loading}
                            dataSource={dataSource}
                            language={language}
                            currency={currency}
                            useCommercialName={useCommercialName}
                            hideMenuPrice={hideMenuPrice}
                            hideRecipePoints={hideRecipePoints}
                            hideEnergyKcal={hideEnergyKcal}
                            showEnergyKcalByPortion={showEnergyKcalByPortion}
                            hideComposition={hideComposition}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}
                            isDuoKiosk={isDuoKiosk}
                            isAdministrationPanel={isAdministrationPanel}
                            columns={this.props.columns}
                        />
                    ) : isAdministrationPanel ? (
                        <NoDataSegment message="There is not enough data to show the menu." />
                    ) : null}
                    <GlobalStyle
                        forceWhiteBackground={
                            this.props.print ||
                            this.props.displayMode === 'print' ||
                            this.props.displayMode === 'week'
                        }
                    />
                </Fragment>
            </ThemeProvider>
        )
    }

    _groupBy = (xs, key) => {
        return xs.reduce(function(rv, x) {
            if (x[key] === '') return rv
            ;(rv[x[key]] = rv[x[key]] || []).push(x)
            return rv
        }, {})
    }
}

export default LoaderConsumer(MenuPanel)
